import script from "./DescrizioneOrdine.vue?vue&type=script&setup=true&lang=js"
export * from "./DescrizioneOrdine.vue?vue&type=script&setup=true&lang=js"

import "./DescrizioneOrdine.vue?vue&type=style&index=0&id=b67d5356&lang=scss&scoped=true"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b67d5356"]])

export default __exports__